import { render } from "./fetchApi.vue?vue&type=template&id=32ac5928&scoped=true"
import script from "./fetchApi.vue?vue&type=script&lang=js"
export * from "./fetchApi.vue?vue&type=script&lang=js"

import "./fetchApi.vue?vue&type=style&index=0&id=32ac5928&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ac5928"]])

export default __exports__